/* global SelectAttendeesVariant */
"use strict";

($dt => {

	// Localized Constants
	const { TOPIC_TYPES, DEBOUNCE_DEFAULT, min_attendees } = $dt.TopicGrid.Constants; 

	// Localized Functions
	//const { on_nothing } = $dt.TopicGrid.Functions;

	class ThisVariant extends SelectAttendeesVariant {
		/**
		 * @param {string} key 
		 * @param {HTMLElement} select_attendees_elem
		 * @param {Block} block
		 * @param {InnerScreen} screen
		 */
		constructor(key, select_attendees_elem, block, screen, addOn) {
			super(key, select_attendees_elem, block, screen, addOn);
			this.num_attendees_elem = this.select_attendees_elem.querySelector('input[name="num_attendees"]');
		}

		setup() {
			this.setup_text_input();
			this.setup_increments();
			if (this.addOn) {
				this.addOn.setup();
			}
		}

		setup_text_input() {
			// Localize
			const { num_attendees_elem, block } = this;

			// Update Functions
			const update_value = () => {
				const { scheduling_info } = block;

				if (num_attendees_elem.value.length > 0) {
					try {
						let value = parseInt(num_attendees_elem.value);
						if (!value || value < min_attendees) {
							value = min_attendees;
						} else if (value > 999) {
							value = 999;
						}

						num_attendees_elem.value = value;
						if (scheduling_info.reservation_attendees !== value) {
							scheduling_info.reservation_attendees = value;
						}

						// Allow Next
						this.screen.ScreenIsValid();

						// Refresh Ajax since community affects reservation attendees amount
						this.screen.RefreshAjax(false);
					} catch (err) {
						// couldn't parse text input
						num_attendees_elem.value = '';
						this.screen.ScreenIsInvalid();
					}
				} else {
					this.screen.ScreenIsInvalid();
				}
			};

			// Changing attendees by typing or adjusting using device incrementers
			num_attendees_elem.addEventListener('keyup', $dt.Util.debounce(update_value, DEBOUNCE_DEFAULT));
			num_attendees_elem.addEventListener('change', $dt.Util.debounce(update_value, DEBOUNCE_DEFAULT));
		}

		setup_increments() {
			// Localize
			const { num_attendees_elem, block } = this;

			// Get Button Elems
			const incrementor_elems = this.select_attendees_elem.querySelectorAll('.increment-wrapper .number-increment');

			// +/- buttons
			incrementor_elems.forEach(button_elem => {
				const direction = button_elem.getAttribute('data-direction');

				// One event for clickers
				button_elem.addEventListener('click', () => {
					const { scheduling_info } = block;

					if (num_attendees_elem.value.length === 0) {
						num_attendees_elem.value = min_attendees;
					}
					try {
						let value = parseInt(num_attendees_elem.value);
						if (direction === 'down') {
							if (value > min_attendees) {
								value--;
							} else {
								value = min_attendees;
							}
						} else {
							if (value < 999) {
								value++;
							} else {
								value = 999;
							}
						}

						num_attendees_elem.value = value;
						if (scheduling_info.reservation_attendees !== value) {
							scheduling_info.reservation_attendees = value;
						}

						// Allow Next
						this.screen.ScreenIsValid();
					} catch (err) {
						// Couldn't parse value
						num_attendees_elem.value = '';
						this.screen.ScreenIsInvalid();
					}
				});

				// Another debounced event for refreshing the calendar
				button_elem.addEventListener('click', $dt.Util.debounce(() => {
					// Refresh Ajax since community affects reservation attendees amount
					this.screen.RefreshAjax(false);
				}, DEBOUNCE_DEFAULT));
			});
		}

		show() {
			const { num_attendees_elem, block } = this;
			const { scheduling_info } = block;

			// Set inputs
			num_attendees_elem.value = scheduling_info.reservation_attendees;

			// Addon
			if (this.addOn) {
				this.addOn.show();
			}
		}
	}
	
	/**
	 * 
	 * @param {HTMLElement} select_attendees_elem 
	 * @param {Block} block 
	 * @param {InnerScreen} calling_screen
	 * @return {ThisVariant}
	 */
	const createCommunityVariant = (select_attendees_elem, block, calling_screen) => {
		const addOnVariant = $dt.TopicGrid.SelectAttendees.createAddOnVariant(select_attendees_elem, block, calling_screen);
		return new ThisVariant(TOPIC_TYPES.COMMUNITY, select_attendees_elem, block, calling_screen, addOnVariant);
	};

	// Save to object
	$dt.TopicGrid.SelectAttendees.createCommunityVariant = createCommunityVariant;

})(window.d3_wp_themejs);
